const FRIENDLY_ERROR_MAP = {
  command_not_found: "The requested speed test command was not found.",
  command_not_pending: "That speed test command is no longer pending.",
  command_expired: "The speed test request expired. Please try again.",
  token_uuid_mismatch: "Device validation failed. Please trigger the test again.",
  uuid_mismatch: "Device validation failed. Please try again.",
  manual_speed_test_disabled: "Manual speed tests are currently disabled.",
  auto_speed_test_disabled: "Automatic speed tests are currently disabled.",
  request_not_found: "The requested record could not be found.",
  internal_server_error: "Something went wrong on the server. Please try again shortly.",
};

export function getFriendlyErrorMessage(rawError, fallback = "Something went wrong. Please try again.") {
  if (!rawError) return fallback;

  const normalized = String(rawError).trim().toLowerCase().replace(/\s+/g, "_");
  if (FRIENDLY_ERROR_MAP[normalized]) {
    return FRIENDLY_ERROR_MAP[normalized];
  }

  // Catch broad backend internals without exposing raw strings.
  if (normalized.includes("internal_server_error")) {
    return FRIENDLY_ERROR_MAP.internal_server_error;
  }

  return fallback;
}

export default getFriendlyErrorMessage;
